<template>
    <div>
        <span>{{minute<10?'0':''}}{{minute}}:{{second<10?'0':''}}{{second}}</span>
    </div>
</template>
<script>

export default {
    props:{
        time:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            minute:'',
            second:'',
            timer:null
        }
    },
    components: {
    },
    created(){
        console.log(this.time)
        let timeArr = this.time.split(':')
        this.minute = Number(timeArr[0])
        this.second = Number(timeArr[1])
        if(this.minute < 0){
            this.minute = 0
            this.second = 0
        }else {
            this.timerFun()
        }
    },
    beforeDestroy(){
        console.log(13212312313)
        clearTimeout(this.timer);
    },
    methods:{
        timerFun(){
            this.timer = setInterval(()=>{
                console.log(123123)
                if(this.second > 0){
                    this.second--
                }else {
                    if(this.minute != 0){
                        this.minute--
                        this.second = 59
                    }else {
                        clearTimeout(this.timer)
                    }
                }
            }, 1000)
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/competition/MinuteCountdown.vue